import React from 'react';
import './AgreementCheckbox.scss';

interface AgreementCheckboxProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    children: React.ReactNode;
    required?: boolean;
}

const AgreementCheckbox = ({checked, onChange, children, required}: AgreementCheckboxProps) => {
    return (
        <label className="AgreementCheckbox">
            <input type="checkbox" checked={checked} required={required}
                   onChange={(e) => onChange(e.target.checked)}/>
            <span>{children}</span>
        </label>
    );
};

export default AgreementCheckbox;
